
  document.documentElement.classList.replace('no-js', 'js');

  window.theme = window.theme || {};
  theme.routes = {
    shop_url: window.location.origin,
    root_url: '/',
    cart_url: '/cart',
    cart_add_url: '/cart/add',
    cart_change_url: '/cart/change',
    cart_update_url: '/cart/update',
    search_url: '/search',
    predictive_search_url: '/search/suggest'
  };

  theme.variantStrings = {
    preOrder: "Pre-order",
    addToCart: "Add to cart",
    soldOut: "Sold Out",
    unavailable: "Unavailable",
    addToBundle: "Add to bundle",
    backInStock: "Notify me when it’s available"
  };

  theme.shippingCalculatorStrings = {
    error: "One or more errors occurred while retrieving the shipping rates:",
    notFound: "Sorry, we do not ship to your address.",
    oneResult: "There is one shipping rate for your address:",
    multipleResults: "There are multiple shipping rates for your address:"
  };

  theme.discountStrings = {
    error: "Discount code cannot be applied to your cart",
    shippingError: "Shipping discounts are shown at checkout after adding an address"
  };

  theme.recipientFormStrings = {
    expanded: "Gift card recipient form expanded",
    collapsed: "Gift card recipient form collapsed"
  };

  theme.quickOrderListStrings = {
    itemsAdded: "[quantity] items added",
    itemAdded: "[quantity] item added",
    itemsRemoved: "[quantity] items removed",
    itemRemoved: "[quantity] item removed",
    viewCart: "View cart",
    each: "[money]\/ea",
    minError: "This item has a minimum of [min]",
    maxError: "This item has a maximum of [max]",
    stepError: "You can only add this item in increments of [step]"
  };

  theme.cartStrings = {
    error: "There was an error while updating your cart. Please try again.",
    quantityError: "You can only add [quantity] of this item to your cart.",
    giftNoteAttribute: "Gift note",
    giftWrapAttribute: "Gift wrapping",
    giftWrapBooleanTrue: "Yes",
    targetProductAttribute: "For"
  };

  theme.dateStrings = {
    d: "d",
    day: "Day",
    days: "Days",
    h: "h",
    hour: "Hour",
    hours: "Hours",
    m: "m",
    minute: "Min",
    minutes: "Mins",
    s: "s",
    second: "Sec",
    seconds: "Secs"
  };theme.strings = {
    recentlyViewedEmpty: "Your recently viewed is empty.",
    close: "Close",
    next: "Next",
    previous: "Previous",
    qrImageAlt: "QR code — scan to redeem gift card"
  };

  theme.settings = {
    moneyFormat: "${{amount}}",
    moneyWithCurrencyFormat: "${{amount}} USD",
    currencyCodeEnabled: false,
    externalLinksNewTab: false,
    cartType: "page",
    isCartTemplate: false,
    pswpModule: "\/\/aura-displays.com\/cdn\/shop\/t\/16\/assets\/photoswipe.min.js?v=41760041872977459911772724190",
    themeName: 'Aura USA',
    themeVersion: '5.3.1',
    agencyId: ''
  };